import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const usuariosRoutes: Routes = [
  {
    path: 'usuarios',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Administração de Usuários',
      breadcrumb: [{ label: 'Administração de Usuários' }],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./usuarios.component').then((m) => m.UsuariosComponent),
        data: {
          title: 'Administração de usuários',
          roles: [Role.USUARIOS_CONSULTAR],
          breadcrumb: [{ label: 'Usuarios', url: '/usuarios' }],
        },
      },
      {
        path: 'cadastrar',
        data: {
          title: 'Cadastrar Usuário',
          roles: [Role.USUARIOS_CADASTRAR],
          breadcrumb: [
            { label: 'Usuários', url: '/usuarios' },
            { label: 'Cadastrar', url: '/usuarios/cadastrar' },
          ],
        },
        loadComponent: () =>
          import('./usuario-form/usuario-form.component').then(
            (m) => m.UsuarioFormComponent,
          ),
      },
      {
        path: 'editar/:id',
        data: {
          title: 'Editar Usuário',
          roles: [Role.USUARIOS_EDITAR],
          breadcrumb: [
            { label: 'Usuários', url: '/usuarios' },
            { label: 'Editar', url: '/usuarios/editar' },
          ],
        },
        loadComponent: () =>
          import('./usuario-form/usuario-form.component').then(
            (m) => m.UsuarioFormComponent,
          ),
      },
      {
        path: 'visualizar/:id',
        data: {
          title: 'Visualizar Usuário',
          roles: [Role.USUARIOS_CONSULTAR],
          breadcrumb: [
            { label: 'Usuários', url: '/usuarios' },
            { label: 'Visualizar', url: '/usuarios/visualizar' },
          ],
        },
        loadComponent: () =>
          import('./usuario-form/usuario-form.component').then(
            (m) => m.UsuarioFormComponent,
          ),
      },
    ],
  },
];
